<span [ngClass]="{'icon-b-checkbox-checked': status, 'icon-o-checkbox-unchecked': !status}"></span>